import { useState } from 'react'
import { Sparkles } from 'lucide-react'
import { useAppStore } from '../store/useAppStore'


export default function LoginModal({ isOpen }) {
  const [token, setToken] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState('')
  const { login } = useAppStore()

  const handleSubmit = async (e) => {
    e.preventDefault()
    console.log('Login attempt with:', { token })
    setIsLoading(true)
    setError('')

    try {
      const result = await login(token)
      console.log('Login result:', result)
      
      if (result.success) {
        console.log('Login successful, calling onLoginSuccess')
      } else {
        console.log('Login failed:', result.error)
        setError(result.error || 'Invalid credentials')
      }
    } catch (err) {
      console.error('Login error:', err)
      setError('Network error. Please try again.')
    } finally {
      setIsLoading(false)
    }
  }

  if (!isOpen) return null

  return (
    <div className="modal-overlay">
      {/* Hypnotizing Animated Background */}
      <div className="hypnotizing-background">
        <div className="floating-orb orb-1" />
        <div className="floating-orb orb-2" />
        <div className="floating-orb orb-3" />
        <div className="floating-orb orb-4" />
        <div className="gradient-mesh" />
      </div>

      <div className="krea-modal" onClick={(e) => e.stopPropagation()}>
        {/* Left Content */}
        <div className="modal-content">
          <h2 className="modal-title">Welcome to Esper AI</h2>
          
          {/* Login Form */}
          <form onSubmit={handleSubmit} className="login-form">
            {error && (
              <div className="error-message">
                <span className="error-icon">⚠️</span>
                <span className="error-text">{error}</span>
              </div>
            )}

            {/* Token Field */}
            <div className="form-field">
              <label className="field-label">Token</label>
              <div className="input-wrapper">
                <input
                  type="text"
                  value={token}
                  onChange={(e) => setToken(e.target.value)}
                  className="modal-input"
                  placeholder="Enter your token"
                  required
                />
              </div>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              disabled={isLoading}
              className="signin-submit"
            >
              {isLoading ? (
                <>
                  <div className="loading-spinner" />
                  <span>Signing in...</span>
                </>
              ) : (
                <>
                  <Sparkles className="submit-icon" />
                  <span>Sign In</span>
                </>
              )}
            </button>
          </form>
          
          <p className="modal-terms">
            This is a beta version. Your data is stored locally on your device for privacy and security.
          </p>
        </div>

        {/* Right Visual */}
        <div className="modal-visual">
          <div className="visual-image"></div>
          <div className="visual-overlay" />
        </div>
      </div>
    </div>
  )
}
